// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Referrals_buttons__rrLXe {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 15px;
}

.Referrals_checkBox__lvuOA {
  background: var(--branded-purple);
}

.Referrals_footer__LmHOQ {
  bottom: 0px;
  z-index: 2;
  background-color: var(--branded-gray);
  width: 100%;
  float: right;
}

.Referrals_participantfooter__MN\\+V7 {
  bottom: 0px;
  z-index: 2;
  background-color: white;
  width: 100%;
  float: right;
}

.Referrals_participantfooter__MN\\+V7 .Referrals_buttonContainer__oLG\\+M {
  text-align: right;
  display: inline-block;
  width: 20%;
}

.Referrals_footer__LmHOQ .Referrals_buttonContainer__oLG\\+M {
  text-align: right;
  display: inline-block;
  width: 20%;
}

.Referrals_footerNoBg__iqs0H {
  bottom: 0px;
  z-index: 2;
  width: 100%;
  float: right;
}

.Referrals_footerNoBg__iqs0H .Referrals_buttonContainerFull__9IM4U {
  text-align: right;
  display: inline-block;
}

.Referrals_button__O3Rhr {
  background: var(--branded-purple);
}

.Referrals_title__hkis6 {
  font-weight: 700;
  font-size: 24px;
  line-height: 32.68px;
  color: #383838;
  margin-top: 1rem;
}
.Referrals_tabContainer__6Vwg0 {
  border: 1px solid #e7e0f1;
  border-radius: 12px;
  padding: 16px;
}
.Referrals_updateButton__YEwKs {
  background-color: white;
  color: #873caa;
  border-radius: 28px;
  font-weight: 600;
  font-size: 14px;
  line-height: 19.07px;
  margin-top: 6px;
}
.Referrals_modalHeader__\\+vdOt {
  font-size: 24px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
  padding-left: 40px;
  padding-right: 40px;
}
.Referrals_hideModalButton__xrshp {
  width: 40px !important;
  height: 40px;
  border-radius: 50%;
  color: #873caa;
  background: rgba(222, 190, 237, 0.5);
  border: none !important;
}
.Referrals_modalHeaderLine__BRZPo {
  height: 3px;
  background-color: #e7e0f1;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.Referrals_modalField__hr3\\+e {
  display: block;
  width: 100%;
  padding-top: 1rem;
}
.Referrals_modalFormContainer__ScsjH {
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 20px;
}
.Referrals_modalFooter__fpgU2 {
  display: flex;
  justify-content: end;
  padding-left: 40px;
  padding-bottom: 20px;
  padding-top: 20px;
  gap: 15px;
}
.Referrals_submitButton__uY-50 {
  background-color: #873caa;
  color: white;
  border-radius: 28px;
  font-weight: 600;
  font-size: 16px;
  line-height: 21.79px;
  padding: 16px 24px 16px 24px;
}
.Referrals_cancelButton__0FKBF {
  background-color: white;
  color: #873caa;
  border-radius: 28px;
  font-weight: 600;
  font-size: 16px;
  line-height: 21.79px;
  padding: 16px 24px 16px 24px;
}
.Referrals_ratingModalHeader__rtixq {
  font-size: 16px;
  font-weight: 700;
  line-height: 21.79px;
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.Referrals_ratingModalHeaderLine__NpGgq {
  height: 3px;
  background-color: #e7e0f1;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.Referrals_ratingModalFormContainer__95GSw {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
}
.Referrals_rankingLabel__EqI8I {
  font-size: 24px;
  font-weight: 700;
  line-height: 32.68px;
}
.Referrals_feedbackLabel__Bwocp {
  font-size: 20px;
  font-weight: 700;
  line-height: 28.68px;
}
.Referrals_rankingLabelSm__PkZsm {
  font-size: 20px;
}
.Referrals_ratingField__9LrXx {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}
.Referrals_ratingButton__p4kQ8 {
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  color: white;
  background-color: #873caa;
  padding: 16px 24px 16px 24px;
  border-radius: 28px;
}
.Referrals_footer__LmHOQ {
  display: flex;
  justify-content: end;
  align-items: center;
  background-color: white;
  padding: 20px 0px 40px 0px;
}
.Referrals_backToTopBtn__vo3f3 {
  background-color: #873caa;
  color: white;
  padding: 16px 24px 16px 24px;
  border-radius: 28px;
  font-weight: 600;
  font-size: 16px;
  line-height: 21.79px;
}
.Referrals_notesContainer__Mgfm5 {
  padding: 24px 32px 24px 32px;
}
.Referrals_notesHeader__oEYa5 {
  display: flex;
  justify-content: end;
  align-items: center;
  padding-bottom: 20px;
}
.Referrals_newNoteButton__XREgj {
  font-weight: 600;
  font-size: 16px;
  line-height: 21.79px;
  padding: 16px 24px 16px 24px;
  border-radius: 28px;
}
.Referrals_submitDisabled__qOqIY {
  background-color: rgba(178, 76, 226, 0.4) !important;
  border: none !important;
  color: white !important;
}
.Referrals_statusModal__A3-P9 {
  width: 35vw;
}
.Referrals_ratingModal__p0U5m {
  width: 35vw;
}
@media (max-width: 768px) {
  .Referrals_statusModal__A3-P9 {
    width: 95vw !important;
  }
  .Referrals_modalHeader__\\+vdOt {
    padding-left: 10px;
    padding-right: 10px;
  }
  .Referrals_modalFormContainer__ScsjH {
    padding-left: 10px;
    padding-right: 10px;
  }
  .Referrals_ratingModal__p0U5m {
    width: 95vw !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Referrals.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,oDAAoD;EACpD,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  margin-bottom: 15px;\n}\n\n.checkBox {\n  background: var(--branded-purple);\n}\n\n.footer {\n  bottom: 0px;\n  z-index: 2;\n  background-color: var(--branded-gray);\n  width: 100%;\n  float: right;\n}\n\n.participantfooter {\n  bottom: 0px;\n  z-index: 2;\n  background-color: white;\n  width: 100%;\n  float: right;\n}\n\n.participantfooter .buttonContainer {\n  text-align: right;\n  display: inline-block;\n  width: 20%;\n}\n\n.footer .buttonContainer {\n  text-align: right;\n  display: inline-block;\n  width: 20%;\n}\n\n.footerNoBg {\n  bottom: 0px;\n  z-index: 2;\n  width: 100%;\n  float: right;\n}\n\n.footerNoBg .buttonContainerFull {\n  text-align: right;\n  display: inline-block;\n}\n\n.button {\n  background: var(--branded-purple);\n}\n\n.title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32.68px;\n  color: #383838;\n  margin-top: 1rem;\n}\n.tabContainer {\n  border: 1px solid #e7e0f1;\n  border-radius: 12px;\n  padding: 16px;\n}\n.updateButton {\n  background-color: white;\n  color: #873caa;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 19.07px;\n  margin-top: 6px;\n}\n.modalHeader {\n  font-size: 24px;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  padding-top: 40px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.hideModalButton {\n  width: 40px !important;\n  height: 40px;\n  border-radius: 50%;\n  color: #873caa;\n  background: rgba(222, 190, 237, 0.5);\n  border: none !important;\n}\n.modalHeaderLine {\n  height: 3px;\n  background-color: #e7e0f1;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n}\n.modalField {\n  display: block;\n  width: 100%;\n  padding-top: 1rem;\n}\n.modalFormContainer {\n  padding-left: 40px;\n  padding-right: 40px;\n  padding-bottom: 20px;\n}\n.modalFooter {\n  display: flex;\n  justify-content: end;\n  padding-left: 40px;\n  padding-bottom: 20px;\n  padding-top: 20px;\n  gap: 15px;\n}\n.submitButton {\n  background-color: #873caa;\n  color: white;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21.79px;\n  padding: 16px 24px 16px 24px;\n}\n.cancelButton {\n  background-color: white;\n  color: #873caa;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21.79px;\n  padding: 16px 24px 16px 24px;\n}\n.ratingModalHeader {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 21.79px;\n  display: flex;\n  justify-content: space-between;\n  padding-top: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.ratingModalHeaderLine {\n  height: 3px;\n  background-color: #e7e0f1;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.ratingModalFormContainer {\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: 20px;\n}\n.rankingLabel {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32.68px;\n}\n.feedbackLabel {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28.68px;\n}\n.rankingLabelSm {\n  font-size: 20px;\n}\n.ratingField {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n}\n.ratingButton {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.79px;\n  color: white;\n  background-color: #873caa;\n  padding: 16px 24px 16px 24px;\n  border-radius: 28px;\n}\n.footer {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  background-color: white;\n  padding: 20px 0px 40px 0px;\n}\n.backToTopBtn {\n  background-color: #873caa;\n  color: white;\n  padding: 16px 24px 16px 24px;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21.79px;\n}\n.notesContainer {\n  padding: 24px 32px 24px 32px;\n}\n.notesHeader {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  padding-bottom: 20px;\n}\n.newNoteButton {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 21.79px;\n  padding: 16px 24px 16px 24px;\n  border-radius: 28px;\n}\n.submitDisabled {\n  background-color: rgba(178, 76, 226, 0.4) !important;\n  border: none !important;\n  color: white !important;\n}\n.statusModal {\n  width: 35vw;\n}\n.ratingModal {\n  width: 35vw;\n}\n@media (max-width: 768px) {\n  .statusModal {\n    width: 95vw !important;\n  }\n  .modalHeader {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .modalFormContainer {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n  .ratingModal {\n    width: 95vw !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": `Referrals_buttons__rrLXe`,
	"checkBox": `Referrals_checkBox__lvuOA`,
	"footer": `Referrals_footer__LmHOQ`,
	"participantfooter": `Referrals_participantfooter__MN+V7`,
	"buttonContainer": `Referrals_buttonContainer__oLG+M`,
	"footerNoBg": `Referrals_footerNoBg__iqs0H`,
	"buttonContainerFull": `Referrals_buttonContainerFull__9IM4U`,
	"button": `Referrals_button__O3Rhr`,
	"title": `Referrals_title__hkis6`,
	"tabContainer": `Referrals_tabContainer__6Vwg0`,
	"updateButton": `Referrals_updateButton__YEwKs`,
	"modalHeader": `Referrals_modalHeader__+vdOt`,
	"hideModalButton": `Referrals_hideModalButton__xrshp`,
	"modalHeaderLine": `Referrals_modalHeaderLine__BRZPo`,
	"modalField": `Referrals_modalField__hr3+e`,
	"modalFormContainer": `Referrals_modalFormContainer__ScsjH`,
	"modalFooter": `Referrals_modalFooter__fpgU2`,
	"submitButton": `Referrals_submitButton__uY-50`,
	"cancelButton": `Referrals_cancelButton__0FKBF`,
	"ratingModalHeader": `Referrals_ratingModalHeader__rtixq`,
	"ratingModalHeaderLine": `Referrals_ratingModalHeaderLine__NpGgq`,
	"ratingModalFormContainer": `Referrals_ratingModalFormContainer__95GSw`,
	"rankingLabel": `Referrals_rankingLabel__EqI8I`,
	"feedbackLabel": `Referrals_feedbackLabel__Bwocp`,
	"rankingLabelSm": `Referrals_rankingLabelSm__PkZsm`,
	"ratingField": `Referrals_ratingField__9LrXx`,
	"ratingButton": `Referrals_ratingButton__p4kQ8`,
	"backToTopBtn": `Referrals_backToTopBtn__vo3f3`,
	"notesContainer": `Referrals_notesContainer__Mgfm5`,
	"notesHeader": `Referrals_notesHeader__oEYa5`,
	"newNoteButton": `Referrals_newNoteButton__XREgj`,
	"submitDisabled": `Referrals_submitDisabled__qOqIY`,
	"statusModal": `Referrals_statusModal__A3-P9`,
	"ratingModal": `Referrals_ratingModal__p0U5m`
};
export default ___CSS_LOADER_EXPORT___;
